// Hrvatski tekstovi — gostu se obraćamo s „vi“.
// Tri oblika množine (one | few | other); pravilo je u libs/i18n/index.ts.
export default {
    general: {
        back:     'Natrag',
        next:     'Dalje',
        cancel:   'Odustani',
        from:     'od',
        night:    'noćenje',
        nights:   '{count} noć | {count} noći | {count} noći',
        loading:  'Učitavanje …',
        language: 'Jezik',
        theme:    'Izgled',
    },
    errors: {
        generic_error: 'Nešto je pošlo po zlu. Pokušajte ponovno.',
        invalid_data:  'Podaci nisu ispravni.',
        not_found:     'Nije pronađeno.',
        offline:       'Ne možemo uspostaviti vezu s hotelom. Provjerite internetsku vezu i pokušajte ponovno.',
        no_house:      'Ovaj objekt trenutačno ne prima online rezervacije.',
        taken:         'Ovu je sobu upravo netko rezervirao. Odaberite drugu sobu ili drugi termin.',
        too_many:      'Previše pokušaja. Pričekajte trenutak i pokušajte ponovno.',
        too_many_guests: 'U ovoj sobi nema mjesta za toliko osoba.',
        booking_failed:  'Rezervaciju nije bilo moguće izvršiti.',
        offer_gone:      'Ponuda više ne vrijedi. Prikazane su redovne cijene objekta.',
    },
    step: {
        dates:   'Termin',
        rooms:   'Soba',
        guest:   'Podaci',
        summary: 'Sažetak',
        done:    'Potvrđeno',
    },
    search: {
        title:          'Rezervirajte sobu',
        lead:           'Odaberite termin i broj osoba; prikazat ćemo vam slobodne sobe i cijenu.',
        arrival:        'Dolazak',
        departure:      'Odlazak',
        adults:         'Odrasli',
        children:       'Djeca',
        submit:         'Pronađi slobodne sobe',
        stay_too_long:  'Boravak može trajati najviše {nights} noći.',
        departure_after: 'Odlazak mora biti nakon dolaska.',
        arrival_past:   'Dolazak ne može biti u prošlosti.',
    },
    package: {
        title: 'U paketu',
        included: 'uključeno',
        surcharges_total: 'Doplate',
        kind_room_service: 'Posluga u sobu',
        kind_dining: 'Obrok',
        kind_facility: 'Sadržaj',
        kind_parking: 'Parkiranje',
        kind_service: 'Usluga',
        kind_product: 'Proizvod',
        when_arrival: 'pri dolasku',
        when_each_night: 'svake noći',
        when_departure: 'pri odlasku',
    },
    rooms: {
        component_gone: 'Dio paketa nije dostupan za te datume',
        component_gone_hint: 'Popunjeno: {what}. Pokušajte s drugim datumima — paket i dalje vrijedi.',
        title:      'Slobodne sobe',
        stay:       '{arrival} – {departure} · {nights} · {guests}',
        none:       'Za odabrani termin nema slobodnih soba.',
        none_hint:  'Pokušajte s drugim terminom ili s manje osoba.',
        change:     'Promijeni termin',
        choose:     'Odaberi',
        per_stay:   'za cijeli boravak',
        left:       'Još {count} slobodna soba | Još {count} slobodne sobe | Još {count} slobodnih soba',
        sleeps:     'Do {count} osobe | Do {count} osobe | Do {count} osoba',
        beds:       '{count} krevet | {count} kreveta | {count} kreveta',
        photo_of:   'Fotografija sobe {name}',
        offer_price: 'cijena po ponudi (−{percent} %)',
        early_booking:       'Rana rezervacija −{percent} %',
        early_booking_saved: 'ušteda {amount}',
        offer_applied: 'Cijene u nastavku su po ovoj ponudi, snižene za {percent} %.',
        offer_gone: 'Ponuda više ne vrijedi',
        offer_gone_hint: 'Objekt ju je povukao ili izmijenio, pa su u nastavku redovne cijene.',
    },
    board: {
        none:       'Samo noćenje',
        breakfast:  'Noćenje s doručkom',
        half_board: 'Polupansion',
        full_board: 'Puni pansion',
        all_inclusive: 'All inclusive',
    },
    guest: {
        title:      'Vaši podaci',
        lead:       'Rezervaciju ćemo potvrditi na ovu adresu e-pošte.',
        first_name: 'Ime',
        last_name:  'Prezime',
        email:      'Adresa e-pošte',
        phone:      'Telefon',
        notes:      'Poruka hotelu',
        notes_hint: 'Neobavezno — na primjer vrijeme dolaska ili posebna želja.',
        required:   'Ovo je polje obavezno.',
        email_bad:  'Upišite ispravnu adresu e-pošte.',
        submit:     'Dalje na sažetak',
    },
    summary: {
        room_only: 'Smještaj',
        payment_optional: 'Možete platiti odmah karticom ili po dolasku, na recepciji.',
        payment_deposit: 'Predujam od {amount} ({percent} % iznosa) potvrđuje rezervaciju — odmah ili putem poveznice iz e-poruke. Ostatak plaćate po dolasku, na recepciji.',
        payment_full: 'Cijeli iznos od {amount} potvrđuje rezervaciju — odmah ili putem poveznice iz e-poruke.',
        title:     'Sažetak',
        lead:      'Provjerite podatke i potvrdite rezervaciju.',
        stay:      'Boravak',
        room:      'Soba',
        offer:     'Ponuda',
        early_booking: 'Rana rezervacija',
        guests:    'Osobe',
        contact:   'Kontakt',
        city_tax:  'Boravišna pristojba {amount} po osobi i noćenju',
        total:     'Ukupno s PDV-om',
        payment:   'Plaćanje po dolasku, na recepciji.',
        cancellation: 'Besplatan otkaz do {date}',
        terms:     'Opći uvjeti',
        accept:    'Slažem se s općim uvjetima i uvjetima otkaza.',
        accept_required: 'Za rezervaciju je potrebno prihvatiti uvjete.',
        submit:    'Potvrdi rezervaciju',
        sending:   'Slanje …',
    },
    done: {
        payment_optional: 'Možete platiti odmah karticom ili po dolasku, na recepciji.',
        payment_remainder: 'Ostatak od {amount} plaćate po dolasku, na recepciji.',
        payment_required: 'Za dovršetak boravka platite {amount}',
        payment_required_hint: 'Soba je rezervirana i čeka vas. Iznos možete platiti odmah ili poslije, putem poveznice iz potvrdne e-poruke.',
        payment_done: 'Plaćanje je zaprimljeno. Hvala!',
        pay_now: 'Plati {amount}',
        pay_later: 'Poveznicu za plaćanje pronaći ćete i u potvrdnoj e-poruci.',
        pay_failed: 'Stranicu za plaćanje nije bilo moguće otvoriti. Pokušajte ponovno ili upotrijebite poveznicu iz e-poruke.',
        title:      'Vaša je rezervacija potvrđena',
        number:     'Broj rezervacije',
        keep:       'Sačuvajte broj — po njemu vas pronalazimo kada nazovete.',
        mail_sent:  'Potvrdu smo poslali na {email}.',
        mail_none:  'Potvrdu vam nismo mogli poslati e-poštom; hotel će vas kontaktirati.',
        payment:    'Plaćanje po dolasku, na recepciji.',
        again:      'Nova rezervacija',
    },
    occupancy: {
        adults:   '{count} odrasla osoba | {count} odrasle osobe | {count} odraslih osoba',
        children: '{count} dijete | {count} djeteta | {count} djece',
    },
    license: {
        title: 'Ova usluga nije uključena',
        lead: 'Ovaj hotel nema uključeno online rezerviranje, pa se putem ove stranice soba ne može rezervirati.',
        contact: 'Nazovite recepciju hotela — rado će vam napraviti rezervaciju.',
    },
    closed: {
        title: 'Rezervacije trenutačno nisu moguće',
        lead:  'Ovaj objekt trenutačno ne prodaje sobe putem interneta. Nazovite recepciju i rado će vam pomoći.',
    },
}
